export default __webpack_public_path__ + "static/oci-upcoming-past-events-163c3162a0dfe1e0388d29704bb407c9.mp4";